// =============================================
// SEAFOODSSHOW — EASY EDIT CONFIG
// =============================================
// Edit this file to customize the website without
// touching any other code. All changes here apply
// site-wide automatically.
// =============================================

const SITE_CONFIG = {

  // ------------------------------------------
  // LOGO
  // Replace with your actual logo URL.
  // You can also put a relative path like: 'assets/logo.png'
  // ------------------------------------------
  logo: {
    url: 'assets/logo.png',
    alt: 'Sea Foods Show',
    height: '56px',
  },

  // ------------------------------------------
  // HERO SECTION
  // Change the background image, headline, and CTA
  // ------------------------------------------
  hero: {
    // Full URL or relative path to an image
    background_image: 'https://cdn.shopify.com/s/files/1/0792/5012/9148/collections/raw_salmon_item_group.png?v=1781121051',
    // Overlay darkness: 0.0 = no overlay, 1.0 = fully dark
    overlay_opacity: 0.55,
    badge_text_en: '4.9★ — 2,000+ happy orders',
    badge_text_ar: '4.9★ — أكثر من 2000 طلب سعيد',
  },

  // ------------------------------------------
  // CONTACT INFO
  // ------------------------------------------
  contact: {
    email:    'info@seafoodsshow.com',
    whatsapp: '+201000000000',       // with country code, no spaces
    instagram: 'https://www.instagram.com/seafoodsshow',
    facebook:  'https://www.facebook.com/seafoodsshow',
  },

  // ------------------------------------------
  // SHOPIFY STORE URL
  // Used for checkout links and product page links
  // ------------------------------------------
  shopify_url: 'https://seafoodsshow.com',

  // ------------------------------------------
  // SHOPIFY STOREFRONT API TOKEN
  // Paste your token here to connect live products + real cart.
  // How to get it → follow SHOPIFY_INTEGRATION.md Step 1
  // Leave empty ('') to use the static scraped data instead.
  // ------------------------------------------
  shopify_storefront_token: 'c34c1d9fec92d98eee577afe7b223906',

  // ------------------------------------------
  // ANNOUNCEMENT BAR
  // Set enabled: false to hide the bar entirely
  // ------------------------------------------
  announcement: {
    enabled: true,
    text_en: '⚡ Same-Day Fast Delivery across Cairo & Giza — Order now!',
    text_ar: '⚡ توصيل سريع في نفس اليوم في القاهرة والجيزة — اطلب الآن!',
  },

  // ------------------------------------------
  // CATEGORY TILE IMAGES
  // Swap the image for any category tile on the homepage.
  // Use full CDN URLs or relative paths.
  // ------------------------------------------
  category_images: {
    bundles:    'https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsAppImage2026-07-26at3.56.39PM.jpg?v=1785074291',
    shrimps:    'https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsAppImage2026-07-26at3.44.07PM.jpg?v=1785073503',
    smoked:     'https://cdn.shopify.com/s/files/1/0792/5012/9148/collections/raw_salmon_item_group.png?v=1781121051',
    raw_salmon: 'https://cdn.shopify.com/s/files/1/0792/5012/9148/collections/raw_salmon_item_group.png?v=1781121051',
    sea_fruits: 'https://cdn.shopify.com/s/files/1/0792/5012/9148/files/DE91AA29-F238-4621-B043-2C79AAB57178.png?v=1780864699',
    sauces:     'https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsAppImage2026-07-26at4.06.52PM.jpg?v=1785074839',
    sahel:      'https://cdn.shopify.com/s/files/1/0792/5012/9148/collections/WhatsApp_Image_2026-07-06_at_7.04.03_PM.jpg?v=1783357507',
  },

  // ------------------------------------------
  // TRUST BAR ITEMS
  // Edit the icon (emoji) and text for each trust signal
  // ------------------------------------------
  trust_items: [
    { icon: '🚚', text_en: 'Same-Day Fast Delivery',       text_ar: 'توصيل سريع في نفس اليوم' },
    { icon: '❄️', text_en: 'Freshly Frozen & Sealed',      text_ar: 'طازج ومجمد ومختوم' },
    { icon: '✅', text_en: 'Quality Guaranteed',            text_ar: 'ضمان الجودة' },
    { icon: '⭐', text_en: '4.9/5 Customer Rating',         text_ar: '4.9/5 تقييم العملاء' },
  ],

  // ------------------------------------------
  // COLORS (CSS overrides)
  // Change the brand colors without editing CSS
  // ------------------------------------------
  colors: {
    navy:   '#0e2a47',   // primary dark color (nav, buttons, footer)
    accent: '#e85d26',   // orange highlight (sale badges, labels)
    // Leave others as-is or set to null to use CSS defaults
  },

  // ------------------------------------------
  // HOMEPAGE SECTION ORDER
  // Reorder, add or remove sections by editing this array.
  // Valid keys: 'bundles', 'shrimps', 'smoked', 'raw_salmon',
  //             'sea_fruits', 'sauces', 'sahel'
  // maxPreview = how many products to show per section (max 4 recommended)
  // ------------------------------------------
  homepage_sections: [
    { key: 'bundles',    maxPreview: 4 },
    { key: 'shrimps',   maxPreview: 4 },
    { key: 'smoked',    maxPreview: 4 },
    { key: 'raw_salmon',maxPreview: 4 },
    { key: 'sea_fruits',maxPreview: 4 },
    { key: 'sauces',    maxPreview: 4 },
  ],

};

// Apply config overrides at runtime
(function applyConfig() {
  // Apply colors as CSS variables
  if (SITE_CONFIG.colors) {
    const root = document.documentElement;
    if (SITE_CONFIG.colors.navy)   root.style.setProperty('--navy', SITE_CONFIG.colors.navy);
    if (SITE_CONFIG.colors.accent) root.style.setProperty('--accent', SITE_CONFIG.colors.accent);
  }

  // Apply logo from config
  if (SITE_CONFIG.logo?.url) {
    document.querySelectorAll(
      '.nav__logo img, .nav__mobile-menu__logo img, .footer__logo img, .nav__mobile-menu__header img'
    ).forEach(img => {
      img.src    = SITE_CONFIG.logo.url;
      img.alt    = SITE_CONFIG.logo.alt || 'Logo';
      img.style.height = SITE_CONFIG.logo.height || '48px';
      img.style.width  = 'auto';
      img.style.display = 'block';
      img.onerror = null; // clear old fallback so it doesn't loop
    });
  }

  // Apply hero background from config
  if (SITE_CONFIG.hero?.background_image) {
    const heroBg = document.querySelector('.hero__bg');
    if (heroBg) {
      const opacity = SITE_CONFIG.hero.overlay_opacity ?? 0.55;
      heroBg.style.background = `
        linear-gradient(105deg,
          rgba(14,42,71,${opacity + 0.3}) 0%,
          rgba(14,42,71,${opacity}) 55%,
          rgba(14,42,71,${opacity - 0.35}) 100%
        ),
        url('${SITE_CONFIG.hero.background_image}') center/cover no-repeat`;
    }
  }

  // Override category tile images from config
  if (SITE_CONFIG.category_images) {
    Object.assign(window._configCategoryImages, SITE_CONFIG.category_images);
  }
})();

// Expose category images for home.js to pick up
window._configCategoryImages = { ...SITE_CONFIG.category_images };
